var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('NavigationBar'),_c('div',{staticClass:"contents"},[_c('PatientEdit',{attrs:{"isLoading":_vm.isLoading,"patient":_vm.currentPatient}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }